/* Winkelwagen-weergave voor stoffen:
   - stof-regels krijgen een meter-stepper (0,1 m per stap), net als op de productpagina
   - Aansnijtoeslag-regel: aantal-stepper verbergen, aantal automatisch gelijktrekken
   - het aantal-bolletje in de header toont meters i.p.v. eenheden van 10 cm */
(function () {
  var FEE_TITLE = 'aansnijtoeslag';
  var busy = false;
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  var style = document.createElement('style');
  style.textContent = [
    // .stof-cart-line (stofregels) wordt al vóór de eerste render verborgen via een
    // vroege <style> in theme.liquid <head> — dat voorkomt de flits van "11" i.p.v. "1,1".
    // Hier alleen nog de toeslagregel (die stepper wordt altijd verborgen, aantal auto-gelijkgetrokken).
    '.stof-fee-line .cart-item__quantity .quantity-popover-wrapper { visibility:hidden; }',
    '.stof-cartqty { display:inline-flex; align-items:stretch; border:1px solid rgb(var(--color-foreground)); border-radius:0.6rem; overflow:hidden; min-height:4.4rem; width:13rem; }',
    '.stof-cartqty__btn { width:3.8rem; flex-shrink:0; border:0; background:transparent; font-size:1.7rem; line-height:1; cursor:pointer; color:rgb(var(--color-foreground)); }',
    '.stof-cartqty__btn:hover { background:rgba(var(--color-foreground),0.06); }',
    '.stof-cartqty__val { flex:1; min-width:0; border:0; background:transparent; padding:0; text-align:center; font-family:inherit; font-size:1.5rem; color:rgb(var(--color-foreground)); appearance:none; }',
    '.stof-cartqty__val:focus, .stof-cartqty__val:focus-visible { outline:0; box-shadow:none; }',
    '.stof-cart-line .cart-item__quantity { display:flex; align-items:center; gap:1rem; flex-wrap:wrap; }'
  ].join('');
  document.head.appendChild(style);

  function parseMeters(txt) {
    var m = (txt || '').match(/([\d]+(?:[.,]\d+)?)\s*m/i);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }
  function fmtM(x) {
    return (Math.round(x * 10) % 10 === 0) ? String(Math.round(x)) : x.toFixed(1).replace('.', ',');
  }
  // Voor de winkelwagen-invoer: gewoon een getal, geen "m"-achtervoegsel nodig.
  function parseTyped(txt) {
    var n = parseFloat(String(txt || '').replace(',', '.').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }
  function snapUp(m) {
    return Math.ceil(m * 10 - 1e-6) / 10;
  }

  function isFee(item) { return (item.title || '').toLowerCase().indexOf(FEE_TITLE) === 0; }
  function isFabric(item) {
    if (isFee(item)) return false;
    var p = item.properties || {};
    if (p.Lengte || p.lengte) return true;
    return (item.vendor || '').toLowerCase() === 'kvadrat';
  }

  function changeLine(line, units, props) {
    if (busy) return;
    busy = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: units, properties: props })
    })
      .then(function (r) { return r.json(); })
      .then(function () { document.location.reload(); })
      .catch(function () { busy = false; });
  }

  function rowForIndex(i) {
    return document.getElementById('CartItem-' + (i + 1)) ||
      document.querySelectorAll('.cart-item')[i] || null;
  }

  function build(cart) {
    var items = cart.items || [];
    var feeIndex = -1;
    var neededFee = 0;
    var meterSum = 0;
    var otherQty = 0;

    items.forEach(function (item, i) {
      if (isFee(item)) {
        feeIndex = i;
        var frow = rowForIndex(i);
        if (frow) frow.classList.add('stof-fee-line');
        return;
      }

      if (!isFabric(item)) { otherQty += item.quantity; return; }

      var units = item.quantity;
      var meters = units / 10;
      meterSum += meters;
      if (meters < 1) neededFee++;

      var row = rowForIndex(i);
      if (!row) return;
      row.classList.add('stof-cart-line');

      var cell = row.querySelector('.cart-item__quantity');
      if (!cell || cell.querySelector('.stof-cartqty')) return;

      var props = {};
      Object.keys(item.properties || {}).forEach(function (k) { props[k] = item.properties[k]; });

      var box = document.createElement('div');
      box.className = 'stof-cartqty';
      box.innerHTML =
        '<button type="button" class="stof-cartqty__btn" data-d="-1" aria-label="Minder">−</button>' +
        '<input type="text" inputmode="decimal" autocomplete="off" class="stof-cartqty__val" aria-label="Lengte in meters" value="' + fmtM(meters) + '">' +
        '<button type="button" class="stof-cartqty__btn" data-d="1" aria-label="Meer">+</button>';

      var val = box.querySelector('.stof-cartqty__val');

      function commit(nu) {
        nu = Math.max(1, nu);
        if (nu === units) { val.value = fmtM(units / 10); return; }
        props.Lengte = fmtM(nu / 10) + ' meter';
        changeLine(i + 1, nu, props);
      }

      box.addEventListener('click', function (e) {
        var b = e.target.closest('.stof-cartqty__btn');
        if (!b || busy) return;
        var d = parseInt(b.dataset.d, 10);
        commit(units + d);
      });

      function commitTyped() {
        var m = parseTyped(val.value);
        if (m === null || m <= 0) { val.value = fmtM(units / 10); return; }
        commit(Math.round(snapUp(m) * 10));
      }
      val.addEventListener('change', commitTyped);
      val.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); val.blur(); }
      });

      cell.insertBefore(box, cell.firstChild);
    });

    // toeslag gelijktrekken
    if (!busy) {
      if (feeIndex === -1 && neededFee === 0) { /* niks */ }
      else if (feeIndex >= 0 && items[feeIndex].quantity === neededFee) { /* klopt al */ }
      else if (feeIndex >= 0) { changeLine(feeIndex + 1, neededFee, items[feeIndex].properties || {}); return; }
    }

    // header-bolletje
    var label;
    if (meterSum > 0 && otherQty === 0) label = fmtM(meterSum);
    else if (meterSum > 0) label = fmtM(meterSum) + ' m +' + otherQty;
    if (label) {
      document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
        var vis = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span:first-child');
        if (vis) vis.textContent = label;
        var sr = bubble.querySelector('.visually-hidden');
        if (sr) sr.textContent = fmtM(meterSum) + ' meter';
      });
    }
  }

  function refresh() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(build).catch(function () {});
  }

  function boot() {
    refresh();
    var target = document.querySelector('#main-cart-items, cart-drawer, .cart-items') || document.body;
    new MutationObserver(function () {
      clearTimeout(boot._t);
      boot._t = setTimeout(refresh, 150);
    }).observe(target, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', refresh);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
